import dayjs from 'dayjs';
import ru from 'dayjs/locale/ru';
import RelativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

export default defineNuxtPlugin(() => {
  dayjs.locale(ru);
  dayjs.extend(RelativeTime);
  dayjs.extend(utc);

  return {
    provide: {
      dayjs,
    },
  };
});
